<template>
    <v-card elevation="0" class="expert-view-section mb-4">
        <v-card-title v-if="title">
            <v-row>
                <v-col cols="auto" class="title-text">{{ title }}</v-col>
                <v-col class="title-space py-0 d-flex align-center">
                    <slot name="title-actions" />
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <slot />
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        title: String,
    },
};
</script>

<style lang="scss" scoped>
.expert-view-section {
    > * {
        padding: 1rem;
    }
    .title-text {
        border-bottom: 3px solid rgba(0, 0, 0, 0.5);
    }
    .title-space {
        border-bottom: 3px solid rgba(0, 0, 0, 0.25);
    }
}
</style>
